import * as React from 'react';
import { autorun } from 'mobx';
import { inject, observer } from 'mobx-react';

import { ContextStore, PageStore } from 'bernie-core';

import { AdvertisingStore, SearchFormStore, FlightsSelectedJourneyReviewStore } from 'stores';
import { isFightInformation } from 'utility';

interface MesoInitProps {
  advertisingStore?: AdvertisingStore;
  context?: ContextStore;
  searchFormStore?: SearchFormStore;
  flightsSelectedJourneyReviewStore?: FlightsSelectedJourneyReviewStore;
  page?: PageStore;
}

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    meso: any;
  }
}

@inject('context', 'searchFormStore', 'advertisingStore', 'flightsSelectedJourneyReviewStore', 'page')
@observer
export class MesoInit extends React.Component<MesoInitProps> {
  private haltPageInfo: () => void;
  private haltTargeting: () => void;
  private savedTargeting: object = null;

  private _setTargeting(): void {
    const {
      searchFormStore,
      page,
      flightsSelectedJourneyReviewStore: { flightsSelectedJourneyReview }
    } = this.props;
    let destinationLocation,
      originLocation = '';
    if (isFightInformation(page)) {
      const journeyInformation = flightsSelectedJourneyReview && flightsSelectedJourneyReview[0].journeyInformation;
      destinationLocation = journeyInformation && journeyInformation.destinationAirportCode;
      originLocation = journeyInformation && journeyInformation.originAirportCode;
    } else {
      const searchForm = searchFormStore && searchFormStore.searchForm;
      destinationLocation = searchForm && searchForm.journeys[0].destinationLocation.airportCode;
      originLocation = searchForm && searchForm.journeys[0].originLocation.airportCode;
    }

    if (window) {
      //setting the target
      window.meso = window.meso || {};
      window.meso.targeting = window.meso.targeting || [];
      //TODO: just destination? what are other factor to target a user?

      const targetingEvent = {
        type: 'update',
        targeting: {
          dest: destinationLocation,
          origin: originLocation,
          locResolver: 'tla'
        }
      };
      if (this._isNewTargeting(targetingEvent.targeting)) {
        window.meso.targeting.push({ type: 'clear' });
        window.meso.targeting.push(targetingEvent);
        this.savedTargeting = targetingEvent.targeting;
      }
    }
  }

  private _isNewTargeting(currentTargeting) {
    if (this.savedTargeting === null) {
      return true;
    }
    for (const key in currentTargeting) {
      if (currentTargeting[key] !== this.savedTargeting[key]) {
        return true;
      }
    }

    return false;
  }

  private getPrivacyConsent() {
    // Retrieve data from context.
    const context = this.props.context;
    const optInPrivacy = context && context.site && context.site.optInPrivacyInfo;
    const canTrack = (optInPrivacy && optInPrivacy.canTrack) || false;
    // canSell defaults to true if it is not defined
    const canSell = !(optInPrivacy && optInPrivacy.canSell === false);

    return {
      canTrack,
      canSell
    };
  }

  private _initializeMesoPageInfo(canTrack: boolean, canSell: boolean): void {
    const { context, advertisingStore } = this.props;
    const siteId = (context && context.site && context.site.id) || '';
    const locale = (context && context.locale) || '';
    const pageId = advertisingStore.pageName;

    const target = {
      type: 'target',
      pageId,
      siteId,
      locale,
      variant: 'pwa',
      canTrack,
      canSell
    };
    window.meso = window.meso || {};
    window.meso.initialize = window.meso.initialize || [];
    window.meso.breakpoints = window.meso.breakpoints || [];
    window.meso.breakpoints.push({ type: 'platform', platform: 'bernie' });
    window.meso.initialize.push(target);
  }

  public componentDidMount(): void {
    const { advertisingStore } = this.props;
    const { canTrack, canSell } = this.getPrivacyConsent();

    if (canTrack) {
      const scriptES6 = document.createElement('script');
      scriptES6.src = advertisingStore.adsloader;
      scriptES6.defer = true;
      scriptES6.async = true;
      scriptES6.type = 'module';
      document.body.appendChild(scriptES6);
      const scriptES5 = document.createElement('script');
      scriptES5.src = advertisingStore.adsloaderes5;
      scriptES5.defer = true;
      scriptES5.noModule = true;
      document.body.appendChild(scriptES5);

      this.haltPageInfo = autorun(() => {
        this._initializeMesoPageInfo(canTrack, canSell);
      });
      this.haltTargeting = autorun(() => {
        this._setTargeting();
      });
    }
  }

  public render(): null {
    return null;
  }
}
